import React, { useState } from "react";
import { api } from "../context/AuthContext";

// Google OAuth button — uses Indosbook's own Google Cloud OAuth client.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleButton = ({ label = "Continue with Google" }) => {
  const [busy, setBusy] = useState(false);

  const handleGoogle = async () => {
    setBusy(true);
    // Google refuses to load inside an iframe (e.g. the editor preview), so open a new tab there
    const framed = window.self !== window.top;
    const tab = framed ? window.open("", "_blank") : null;
    try {
      const { client_id } = (await api.get("/auth/google/config")).data;
      const state = Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, "0")).join("");
      localStorage.setItem("google_oauth_state", state);
      const params = new URLSearchParams({
        client_id,
        redirect_uri: window.location.origin + "/auth/google",
        response_type: "code",
        scope: "openid email profile",
        state,
        prompt: "select_account",
      });
      const url = `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
      if (tab) {
        tab.location.href = url;
        setBusy(false);
      } else {
        window.location.href = url;
      }
    } catch {
      if (tab) tab.close();
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid="google-auth-button"
      onClick={handleGoogle}
      disabled={busy}
      className="flex h-12 w-full items-center justify-center gap-3 rounded-full border border-gray-300 bg-white font-semibold text-gray-700 transition-colors hover:bg-gray-50 disabled:opacity-60"
    >
      <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.26 1.06-3.71 1.06-2.85 0-5.27-1.93-6.13-4.52H2.18v2.84A11 11 0 0 0 12 23z" />
        <path fill="#FBBC05" d="M5.87 14.11a6.6 6.6 0 0 1 0-4.22V7.05H2.18a11 11 0 0 0 0 9.9l3.69-2.84z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.05l3.69 2.84C6.73 7.31 9.15 5.38 12 5.38z" />
      </svg>
      {busy ? "Opening Google…" : label}
    </button>
  );
};

export default GoogleButton;
